<template>
  <div class="next-path">
    <div v-if="trailerId" class="next-path__video-wrapper">
      <SampleVideo :videoId="trailerId" :autostart="false" />
      <div class="next-path__remarks" v-if="remarks">
        <strong>CLOSING REMARKS: </strong>{{ remarks }}
      </div>
    </div>
    <div class="next-path__content-wrapper" v-if="nextLP">
      <p class="next-path__subtitle">
        Recommended Next
      </p>
      <h3 class="next-path__title">{{ nextLP.name }}</h3>
      <div class="next-path__details">
        <div class="next-path__details-left">
          <div class="next-path__data">
            <span class="next-path__tag">Duration:</span>
            {{ duration }}
          </div>
          <div class="next-path__data">
            <span class="next-path__tag">Difficulty:</span>
            <Difficulty
              :difficulty="nextLP.difficulty"
              :alwaysVisible="true"
              :colored="true"
            />
          </div>
        </div>
        <div class="next-path__activities">
          <div class="next-path__data">
            <div class="next-path__tag">Activities:</div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_groups > 0"
            >
              {{ nextSummary.total_groups }}
              {{ nextSummary.total_groups > 1 ? 'sections' : 'section' }}
            </div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_courses > 0"
            >
              {{ nextSummary.total_courses }}
              {{ nextSummary.total_courses > 1 ? 'courses' : 'course' }}
            </div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_videos > 0"
            >
              {{ nextSummary.total_videos }}
              {{ nextSummary.total_videos > 1 ? 'videos' : 'video' }}
            </div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_quizzes > 0"
            >
              {{ nextSummary.total_quizzes }}
              {{ nextSummary.total_quizzes > 1 ? 'quizzes' : 'quiz' }}
            </div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_labs > 0"
            >
              {{ nextSummary.total_labs }}
              {{ nextSummary.total_labs > 1 ? 'labs' : 'lab' }}
            </div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_exercises > 0"
            >
              {{ nextSummary.total_exercises }}
              {{ nextSummary.total_exercises > 1 ? 'exercises' : 'exercise' }}
            </div>
            <div
              class="next-path__data-detail"
              v-show="nextSummary.total_iframes > 0"
            >
              {{ nextSummary.total_iframes }}
              {{ nextSummary.total_iframes > 1 ? 'slides' : 'slide' }}
            </div>
          </div>
        </div>
      </div>
      <div class="next-path__actions">
        <router-link
          :to="$buildContentLink('path', nextLP)"
          class="btn btn--secondary"
          >Go to Learning Path</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import Difficulty from '@/components/properties/Difficulty.vue'
import SampleVideo from '@/components/media/SampleVideo.vue'

export default {
  name: 'LearningPathNextContent',
  components: {
    Difficulty,
    SampleVideo,
  },
  props: {
    learningPath: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      sections: 0,
      courses: 0,
    }
  },
  computed: {
    duration() {
      const { duration_in_seconds: duration } = this.nextLP
      return this.$duration.durationFromSecs(duration)
    },
    trailerId() {
      const { closing_video_jwplayer_id } = this.learningPath
      return closing_video_jwplayer_id
    },
    nextLP() {
      const { next_learning_path } = this.learningPath
      return next_learning_path
    },
    remarks() {
      const { closing_video_remarks } = this.learningPath
      return closing_video_remarks
    },
    nextSummary() {
      const { summary } = this.nextLP
      return summary
    },
  },
}
</script>

<style lang="scss" scoped>
.next-path {
  display: flex;
  flex-wrap: wrap;
  padding: 30px 25px;
  color: var(--white);
  @include tablet {
    padding: 50px 40px;
    flex-wrap: nowrap;
  }
  &__video-wrapper {
    width: 100%;
    @include tablet {
      width: 50%;
    }
    display: flex;
    flex-wrap: wrap;
  }
  &__remarks {
    padding: 20px;
    font-size: 14px;
  }
  &__content-wrapper {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 0 20px;
    align-content: flex-start;
    flex-direction: column;
    margin-top: 20px;
    @include tablet {
      width: 50%;
      padding: 0 50px 80px;
      margin-top: 0;
    }
  }
  &__title {
    font-size: rem(24px);
    margin-top: 0;
  }
  &__subtitle {
    text-transform: uppercase;
    margin: 0;
    color: var(--lighter-gray);
  }
  &__details {
    display: flex;
    justify-content: space-between;
  }
  &__tag {
    text-transform: uppercase;
    color: var(--lighter-gray);
    width: 100%;
    display: block;
    margin-bottom: 5px;
  }
  &__data {
    margin-bottom: 15px;
    &-detail {
      font-family: var(--font-medium);
      font-weight: normal;
    }
  }
  &__actions {
    margin-top: 30px;
    @include tablet {
      margin-top: auto;
    }
  }
}
</style>
